import { useBillingServiceStore } from '@billing/AppProvider'
import { Stack } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { ConfirmationDialog, FileDragAndDropzone } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { useDropzone } from 'react-dropzone'
import { useOperationEquipmentMessageHandler } from '../../hooks/useCommodityMessageHandler'
import { CatalogueDialogUIStore } from '../../stores/catalogue-dialog.ui-store'

interface Props {
  dialogStore: CatalogueDialogUIStore
}

export const CatelogUploadDialog = observer(({ dialogStore }: Props) => {
  const { t } = useTranslate()
  const { appStore } = useBillingServiceStore()
  const { getExceptionMessage } = useOperationEquipmentMessageHandler()

  const { getRootProps, getInputProps } = useDropzone({
    maxFiles: 1,
    accept: {
      'text/csv': ['.csv'],
    },
    onDrop: (acceptedFiles: File[]) => {
      if (acceptedFiles.length > 0) {
        dialogStore.setFile(acceptedFiles[0])
      }
    },
  })

  const handleCancel = () => {
    dialogStore.toggleImport()
    dialogStore.setFile(undefined)
  }

  const handleSubmit = async () => {
    try {
      await dialogStore.submitFile()
      appStore.setShowAlert(
        'success',
        t('commoditiesImported', 'Commodities has been imported successfully.'),
      )
    } catch (error: any) {
      appStore.setShowAlert('error', getExceptionMessage(error))
    }
  }

  return (
    <ConfirmationDialog
      open={dialogStore.isImportOpen}
      formId='catalogue-form'
      title={t('importCatelogue', 'Import catalogue')}
      primaryActionText={t('upload', 'Upload')}
      closeLabel={t('cancel', 'Cancel')}
      onConfirm={handleSubmit}
      onClose={handleCancel}
      maxWidth='xs'
    >
      <Stack gap={2} sx={{ margin: '1rem' }}>
        <FileDragAndDropzone
          inputProps={getInputProps()}
          rootProps={getRootProps()}
          setFile={(file?: File) => dialogStore.setFile(file)}
        />
      </Stack>
    </ConfirmationDialog>
  )
})
